/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { MarkdownContent } from 'components/artists/MarkdownContent'
import { CollapsableTextContent } from 'components/common/CollapsableTextContent'

interface Props {
  description?: string
}

export function ArtistDescription({ description }: Props) {
  if (!description) return null

  return (
    <CollapsableTextContent className='mt-5 sm:mb-1.5'>
      <MarkdownContent>{description}</MarkdownContent>
    </CollapsableTextContent>
  )
}
